/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_itinerary__add_step = /** @type {(inputs: {}) => string} */ () => {
	return `Etappe hinzufügen`
};

const en_itinerary__add_step = /** @type {(inputs: {}) => string} */ () => {
	return `Add a step`
};

const es_itinerary__add_step = /** @type {(inputs: {}) => string} */ () => {
	return `Añadir escala`
};

const fr_itinerary__add_step = /** @type {(inputs: {}) => string} */ () => {
	return `Ajouter une étape`
};

const it_itinerary__add_step = /** @type {(inputs: {}) => string} */ () => {
	return `Aggiungi come tappa`
};

const nl_itinerary__add_step = /** @type {(inputs: {}) => string} */ () => {
	return `Een tussenstop toevoegen`
};

const pt_itinerary__add_step = /** @type {(inputs: {}) => string} */ () => {
	return `Adicionar uma paragem`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__add_step = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.itinerary__add_step(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("itinerary__add_step", locale)
	if (locale === "de") return de_itinerary__add_step(inputs)
	if (locale === "en") return en_itinerary__add_step(inputs)
	if (locale === "es") return es_itinerary__add_step(inputs)
	if (locale === "fr") return fr_itinerary__add_step(inputs)
	if (locale === "it") return it_itinerary__add_step(inputs)
	if (locale === "nl") return nl_itinerary__add_step(inputs)
	return pt_itinerary__add_step(inputs)
};